import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});
Font.register({
  family: 'Poppins-Bold',
  src: '/path/to/Poppins-Bold.ttf',
});

function formatdate(newdate) {
        if (!newdate) return ''; // Handle null or undefined values gracefully

        const date = new Date(newdate);
        if (isNaN(date.getTime())) return ''; // Handle invalid dates

        const day = String(date.getDate()).padStart(2, '0');
       const month = date.getMonth() + 1; 
        const year = date.getFullYear();

        return `${day} - ${month} - ${year}`;
    }
const WithoutAbsentReport = ({pdfdata}) => {
    console.log("Data in WithoutAbsentReport:", pdfdata);
  return (
    <Document>
        {pdfdata.map((data, index) => (
        <Page  key = {index} size= "A4" style={{paddingTop: 150, paddingLeft: 90, paddingRight: 60}}>
            
            <View style={{width: "100%", height:"96%",}}>
                <View style={{width:"100%", height:"2.5%", flexDirection:"row"}}>
                    <View style={{width:"75%", height:'100%'}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8.5, fontWeight: 600}}>To,</Text>
                    </View>
                    <View style={{width:"25%", height:'100%', flexDirection:"row",gap: 4}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>Date:</Text>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>{formatdate(data.Result_date)}</Text>
                    </View>
                </View>

                <View style={{width:"100%", height:"12%", flexDirection:"row",}}>
                    <View style={{width:"60%", height:'100%', flexDirection: "column"}}>
                        <View style={{width: "100%", height:"20%",paddingTop: 2}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>Dear Parents</Text>
                        </View>
                        <View style={{width: "100%", height:"40%",paddingTop: 1}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>
                                {data.Present_Address}
                            </Text>
                        </View>
                        <View style={{width: "100%", height:"20%"}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>{data.Present_City}</Text>
                        </View>
                        <View style={{width: "100%", height:"20%"}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8.5,}}>{data.Present_State}, {data.Present_Country}</Text>
                        </View>
                    </View>
                    <View style={{width:"40%", height:'100%'}}>
                        
                    </View>
                </View>

                <View style={{width:"100%", height:"7%", flexDirection:'row', gap: 5, paddingTop: 20}}>
                    <Text style={{fontFamily: 'Poppins', fontSize: 9, fontWeight: 600}}>SUB. :</Text>
                        <Text style={{ fontFamily: 'Poppins', fontSize: 9 }}>
                          PERFORMANCE OF{' '}
                          <Text style={{ fontFamily: 'Poppins', fontWeight: 'bold', textDecoration: 'underline' }}>
                            {data.Student_Name}
                          </Text>{' '}
                          IN SUVIDYA INSTITUTE OF TECHNOLOGY PVT. LTD
                        </Text>


                </View>

                <View style={{width:"100%", height:"4%", border: "1px solid black", flexDirection:'row', gap: 5, justifyContent:"center", alignItems:"center"}}>
                    <Text style={{fontFamily: 'Poppins', fontSize: 9, fontWeight: 600}}>PARTICIPANT PERFORMANCE REPORT</Text>
                </View>
                 <View style={{width:"100%", height:"6%", border: "1px solid black",borderTop:"1px solid black", flexDirection:'column'}}>
                    <View style={{width:"100%", height:"50%", flexDirection:'row', justifyContent:"center", alignItems:"center"}}>
                        <View style={{width:"50%", height:"100%", justifyContent:"flex-start", alignItems:"center",flexDirection: "row", gap: 3, borderRight:"1px solid black", paddingLeft: 20}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5, marginLeft: -10,}}>Name :</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Student_Name}</Text>
                        </View>
                        <View style={{width:"50%", height:"100%", justifyContent:"flex-start", alignItems:"center", flexDirection: "row", gap: 3, paddingLeft: 20}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5, marginLeft: -10,}}>Training Programme:</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Course_Name}</Text>
                        </View>
                    </View>
                    <View style={{width:"100%", height:"50%", flexDirection:'row', justifyContent:"center", alignItems:"center"}}>
                        <View style={{width:"50%", height:"100%", justifyContent:"flex-start", alignItems:"center",flexDirection: "row", gap: 3, borderRight:"1px solid black", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}>ID. :</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Student_Code}</Text>
                        </View>
                        <View style={{width:"50%", height:"100%", justifyContent:"flex-start", alignItems:"center", flexDirection: "row", gap: 3, paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}>Batch No. :</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Batch_code}</Text>
                        </View>
                    </View>
                </View>

                <View style={{width:"100%", height:"12%", border:"1px solid black",  top:"1px", flexDirection: "row"}}>
                    <View style={{width:"7%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>01</Text>
                    </View>
                     <View style={{width:"24%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Attendance Record</Text>
                    </View>
                    <View style={{width:"32%", height:"100%", borderRight:"1px soid black", justifyContent:"center", alignItems:"center", flexDirection:"column"}}>
                        <View style={{width:"100%", height:"70%", borderBottom:"1px solid black", flexDirection:"column"}}>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>Total Lectures</Text>
                            </View>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>Attended Lectures</Text>
                            </View>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>Total No. of Absent Days</Text>
                            </View>
                        </View>
                        <View style={{width:"100%", height:"30%", justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>Attendance (%)</Text>
                        </View>
                    </View>
                    <View style={{width:"39%", height:"100%", justifyContent:"center", alignItems:"center", flexDirection:"column"}}>
                        <View style={{width:"100%", height:"70%", borderBottom:"1px solid black", flexDirection:"column"}}>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Total_Lectures}</Text>
                            </View>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.AttenLectures}</Text>
                            </View>
                            <View style={{width:"100%", height:"33.33%",justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Absents}</Text>
                            </View>
                        </View>
                        <View style={{width:"100%", height:"30%", justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                             <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>
                              {data.Total_Lectures > 0 
                                ? ((data.AttenLectures / data.Total_Lectures) * 100).toFixed(2) + "%" 
                                : "0%"}
                            </Text>
                        </View>
                    </View>
                </View>

                <View style={{width:"100%", height:"5%", border:"1px solid black", borderTop: "npne" , flexDirection: "row"}}>
                    <View style={{width:"7%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>02</Text>
                    </View>
                     <View style={{width:"24%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Assignments</Text>
                    </View>
                        <View style={{width:"32%", height:"100%",borderRight:"1px solid black",  justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}>Marks obtained in Assignment/s</Text>
                        </View>
                    
                        <View style={{width:"39%", height:"100%", justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Ass1_Given + data.Ass2_Given + data.Ass3_Given + data.Ass4_Given + data.Ass5_Given + data.Ass6_Given + data.Ass7_Given + data.Ass8_Given + data.Ass9_Given + data.Ass10_Given} / {data.Ass1_Max + data.Ass2_Max + data.Ass3_Max + data.Ass4_Max + data.Ass5_Max + data.Ass6_Max + data.Ass7_Max + data.Ass8_Max + data.Ass9_Max + data.Ass10_Max}</Text>
                        </View>
                </View>
                <View style={{width:"100%", height:"5%", border:"1px solid black", borderTop: "npne" , flexDirection: "row"}}>
                    <View style={{width:"7%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>03</Text>
                    </View>
                     <View style={{width:"24%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Unit Tests</Text>
                    </View>
                        <View style={{width:"32%", height:"100%",borderRight:"1px solid black",  justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}>Marks obtained in Unit Test/s</Text>
                        </View>
                    
                        <View style={{width:"39%", height:"100%", justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Test1_Given + data.Test2_Given + data.Test3_Given + data.Test4_Given + data.Test5_Given + data.Test6_Given + data.Test7_Given + data.Test8_Given + data.Test9_Given + data.Test10_Given} / {data.Test1_Max + data.Test2_Max + data.Test3_Max + data.Test4_Max + data.Test5_Max + data.Test6_Max + data.Test7_Max + data.Test8_Max + data.Test9_Max + data.Test10_Max} </Text>
                        </View>
                </View>
                <View style={{width:"100%", height:"5%", border:"1px solid black", borderTop: "npne" , flexDirection: "row"}}>
                    <View style={{width:"7%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>04</Text>
                    </View>
                     <View style={{width:"24%", height:"100%", borderRight: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                        <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Discipline</Text>
                    </View>
                        <View style={{width:"32%", height:"100%",borderRight:"1px solid black",  justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}>Weightage-2%</Text>
                        </View>
                    
                        <View style={{width:"39%", height:"100%", justifyContent:"center", alignItems:"flex-start", paddingLeft: 10}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>{data.Discipline}</Text>
                        </View>
                </View>

                <View style={{width:"100%", height:"3%", justifyContent:"flex-start", alignItems:"center", flexDirection:"row", gap: 30}}>
                    <Text style={{fontFamily: 'Poppins', fontSize: 8,}}>Performance :</Text>    
                    <Text style={{fontFamily: 'Poppins', fontSize: 8,borderBottom:"1px solid black", width:'85%', paddingTop: 8}}>{data.Grade}</Text>              
                </View>
                
                <View style={{width:"100%", height:'3%', border: "1px solid black", justifyContent:"center", alignItems:"center"}}>
                    <Text style={{fontFamily: 'Poppins', fontSize: 9,fontWeight: 600}}>PERFORMANCE </Text>
                </View>
                    <View style={{width:"100%", height:"12%", borderBottom:"1px solid black",borderRight:"1px solid black",borderLeft:"1px solid black", flexDirection:'row', }}>
                        <View style={{width:"50%", height:"100%", borderRight:"1px solid black", flexDirection:'column',paddingTop: 2}}>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600, paddingLeft: 5}}>A+ </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>A </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600, paddingLeft: 5}}>B+ </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>B </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>C </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>D </Text>
                            </View>

                        </View>

                        <View style={{width:"50%", height:"100%", flexDirection:'column',paddingTop: 2}}>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>90% - 100%</Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>80% - 89.99% </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>70% - 79.99% </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>60% - 69.99% </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>50% - 59.99% </Text>
                            </View>
                            <View style={{width:"100%", height:"16.67%", justifyContent: "center", alignItems:"center"}}>
                                <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: 600}}>Below 49.99% </Text>
                            </View>
                        </View>                        
                    </View>


                    <View style={{width:"100%", height:"6%", flexDirection:'column', justifyContent:"center", alignItems:'center'}}>
                         <Text style={{fontFamily: 'Poppins', fontSize: 7, paddingRight: 50}}>This is the Performance of <Text style={{fontFamily: 'Poppins', fontSize: 7.5,fontWeight: "bold"}}> {data.Student_Name}</Text> in Suvidya Institute of Technology during his period from to 
                            Please sign this report and submit back to Training Coordinator.
                        </Text>
                    </View>
                    <View style={{width:"100%", height:"2%", flexDirection:'column', justifyContent:"center", alignItems:'flex-start',}}>
                         <Text style={{fontFamily: 'Poppins', fontSize: 7}}>
                            Thanking and looking forward to your cooperation.
                        </Text>
                    </View>
                
                <View style={{width:"100%", height:"12%", paddingTop: 20}}>
                    <View style={{width:"100%", height:"40%", border:'1px solid black', flexDirection:"row"}}>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black'}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}> </Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black'}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}> </Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black'}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}> </Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center",}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 7.5,}}> </Text>
                        </View>
                    </View>
                     <View style={{width:"100%", height:"50%", border:'1px solid black',borderTop:"none", flexDirection:"row"}}>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black', flexDirection:"column"}}>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8, fontWeight: 600}}> {data.faculty1}</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Training Coordinator </Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black',flexDirection:"column"}}>
                             <Text style={{fontFamily: 'Poppins', fontSize: 8, fontWeight: 600}}> {data.faculty2}</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Faculty </Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", borderRight:'1px solid black', flexDirection:"column"}}>
                             <Text style={{fontFamily: 'Poppins', fontSize: 8, fontWeight: 600}}> Student</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Signature</Text>
                        </View>
                        <View style={{width:'25%',height:"100%", justifyContent:"center", alignItems: "center", flexDirection:"column"}}>
                             <Text style={{fontFamily: 'Poppins', fontSize: 8, fontWeight: 600}}>Parents</Text>
                            <Text style={{fontFamily: 'Poppins', fontSize: 8,fontWeight: 600}}>Signature </Text>
                        </View>
                    </View>
                </View>
            </View>
            
        </Page>
        ))}
        {/* till here  */}
    </Document>
  )
}

export default WithoutAbsentReport